<div class="container-fluid h-100">
  <div class="row h-100">
    <!-- <app-chart-widget [widgetPanelCharts]="widgetPanelCharts" [widgetPanel]="{ style: {'max-height': '450px', 'height': '100%'}}" [title]="title"></app-chart-widget> -->
    <app-chart-widget
      [widgetPanelCharts]="widgetPanelCharts"
      [title]="title"
      [widgetPanel]="widgetPanel"
    ></app-chart-widget>
  </div>
</div>
